import {
  getLeoUuid,
  LeoUUID,
  getObject,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
/* eslint-disable import/export */
export abstract class GetAddMultipleSpocsToProjectScheduleJobStatusRPC implements
  LeoRPC<GetAddMultipleSpocsToProjectScheduleJobStatusRPC.Request, GetAddMultipleSpocsToProjectScheduleJobStatusRPC.Response, GetAddMultipleSpocsToProjectScheduleJobStatusRPC.Errors.Errors>
{
  abstract execute(
    request: GetAddMultipleSpocsToProjectScheduleJobStatusRPC.Request
  ): Promise<LeoRPCResult<GetAddMultipleSpocsToProjectScheduleJobStatusRPC.Response, GetAddMultipleSpocsToProjectScheduleJobStatusRPC.Errors.Errors>>;
}

export namespace GetAddMultipleSpocsToProjectScheduleJobStatusRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    projectId: string;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isGetAddMultipleSpocsToProjectScheduleJobStatusRPCRequest: boolean = true;
  
    readonly projectId: LeoUUID;
  
  
    constructor(
    projectId: LeoUUID
    ) {
      this.projectId = projectId;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const projectId = getLeoUuid(dto, "projectId", InvalidRequestProjectIdError);
      return new Request(
        projectId
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          projectId: this.projectId.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `GetAddMultipleSpocsToProjectScheduleJobStatusRPC(projectId='${this.projectId}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  
  export namespace ResponseEnums {
    /* eslint-disable @typescript-eslint/no-shadow */
    export namespace AddMultipleSpocsToProjectScheduleJobStatus {
      export enum AddMultipleSpocsToProjectScheduleJobStatus {
        IN_PROGRESS = "IN_PROGRESS",
        COMPLETED = "COMPLETED",
      }
    
      export interface AddMultipleSpocsToProjectScheduleJobStatusDTO {
        case: string;
      }
    
      export const fromDTO = (dto: AddMultipleSpocsToProjectScheduleJobStatusDTO): AddMultipleSpocsToProjectScheduleJobStatus => {
        if (dto === undefined || dto === null) {
          throw new InvalidResponseAddMultipleSpocsToProjectScheduleJobStatusError(
            `Invalid DTO ${dto} provided for AddMultipleSpocsToProjectScheduleJobStatus.AddMultipleSpocsToProjectScheduleJobStatus`
          );
        }
        switch (dto.case) {
          case "IN_PROGRESS":
            return AddMultipleSpocsToProjectScheduleJobStatus.IN_PROGRESS;
          case "COMPLETED":
            return AddMultipleSpocsToProjectScheduleJobStatus.COMPLETED;
          default:
            throw new InvalidResponseAddMultipleSpocsToProjectScheduleJobStatusError(
              `Case ${dto.case} is not valid case of AddMultipleSpocsToProjectScheduleJobStatus.AddMultipleSpocsToProjectScheduleJobStatus`
            );
        }
      };
    
      export const toDTO = (addMultipleSpocsToProjectScheduleJobStatus: AddMultipleSpocsToProjectScheduleJobStatus): AddMultipleSpocsToProjectScheduleJobStatusDTO => {
        const enumDTO = {
          case: AddMultipleSpocsToProjectScheduleJobStatus[addMultipleSpocsToProjectScheduleJobStatus],
        };
        return enumDTO;
      };
    }
    
  }
  export interface ResponseDTO {
    addMultipleSpocsToProjectScheduleJobStatus: ResponseEnums.AddMultipleSpocsToProjectScheduleJobStatus.AddMultipleSpocsToProjectScheduleJobStatusDTO;
  }
  
  export class Response implements LeoRPCResponse {
    readonly isGetAddMultipleSpocsToProjectScheduleJobStatusResponse: boolean = true;
  
    readonly addMultipleSpocsToProjectScheduleJobStatus: ResponseEnums.AddMultipleSpocsToProjectScheduleJobStatus.AddMultipleSpocsToProjectScheduleJobStatus;
  
  
    constructor(
    addMultipleSpocsToProjectScheduleJobStatus: ResponseEnums.AddMultipleSpocsToProjectScheduleJobStatus.AddMultipleSpocsToProjectScheduleJobStatus
    ) {
      this.addMultipleSpocsToProjectScheduleJobStatus = addMultipleSpocsToProjectScheduleJobStatus;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const addMultipleSpocsToProjectScheduleJobStatus = ResponseEnums.AddMultipleSpocsToProjectScheduleJobStatus.fromDTO(getObject(dto, "addMultipleSpocsToProjectScheduleJobStatus", InvalidResponseAddMultipleSpocsToProjectScheduleJobStatusError));
      return new Response(
        addMultipleSpocsToProjectScheduleJobStatus
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          addMultipleSpocsToProjectScheduleJobStatus: ResponseEnums.AddMultipleSpocsToProjectScheduleJobStatus.toDTO(this.addMultipleSpocsToProjectScheduleJobStatus)
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `GetAddMultipleSpocsToProjectScheduleJobStatus(addMultipleSpocsToProjectScheduleJobStatus='${this.addMultipleSpocsToProjectScheduleJobStatus}')`;
  };
  

  export enum RPCError {
    InvalidProjectId = "INVALID_PROJECT_ID"
  }

  export namespace Errors {
    
    export interface InvalidProjectIdDTO {
      code: string;
    }
    
    export class InvalidProjectId extends LeoRPCError<RPCError> {
      readonly isInvalidProjectId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidProjectId;
        super(code);
      }
    
    
      toDTO(): InvalidProjectIdDTO {
        const dto: InvalidProjectIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidProjectId.prototype.toString = function toString(): string {
      return `GetAddMultipleSpocsToProjectScheduleJobStatusRPC.INVALID_PROJECT_ID()`;
    };
    

    export type Errors = InvalidProjectId;
    export type ErrorsDTO = InvalidProjectIdDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidProjectId:
          return new InvalidProjectId();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestProjectIdError extends GetAddMultipleSpocsToProjectScheduleJobStatusRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestProjectIdError";
  }
}

export class InvalidResponseAddMultipleSpocsToProjectScheduleJobStatusError extends GetAddMultipleSpocsToProjectScheduleJobStatusRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseAddMultipleSpocsToProjectScheduleJobStatusError";
  }
}

export class InvalidResponseAddMultipleSpocsToProjectScheduleJobStatusInProgressError extends InvalidResponseAddMultipleSpocsToProjectScheduleJobStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseAddMultipleSpocsToProjectScheduleJobStatusInProgressError";
  }
}

export class InvalidResponseAddMultipleSpocsToProjectScheduleJobStatusCompletedError extends InvalidResponseAddMultipleSpocsToProjectScheduleJobStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseAddMultipleSpocsToProjectScheduleJobStatusCompletedError";
  }
}

export class InvalidResponseInvalidProjectIdError extends GetAddMultipleSpocsToProjectScheduleJobStatusRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidProjectIdError";
  }
}

